import { render, staticRenderFns } from "./CategoryHeadline.vue?vue&type=template&id=4c6b692b&scoped=true"
import script from "./CategoryHeadline.vue?vue&type=script&lang=js"
export * from "./CategoryHeadline.vue?vue&type=script&lang=js"
import style0 from "./CategoryHeadline.vue?vue&type=style&index=0&id=4c6b692b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6b692b",
  null
  
)

export default component.exports